import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { PlasticSignConfiguration } from "@domain/project/configurations/plastic-sign-configuration";
import { FgdsProject } from "@domain/project/fgds-project";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { ConfiguredProductComponent } from "@project/floorplanner/floorplan-menu/fgds/configured-product/configured-product.component";
import { FloorplanProductMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-product-menu/floorplan-product-menu.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-plastic-sign-menu",
  templateUrl: "./floorplan-plastic-sign-menu.component.html",
  styleUrls: ["./floorplan-plastic-sign-menu.component.scss"],
  imports: [UiKitModule, FloorplanProductMenuComponent, ConfiguredProductComponent],
})
export class FloorplanPlasticSignMenuComponent {
  private floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplan: Floorplan;

  protected readonly tooltipTextPlasticSigns: string = $localize`:@@global.plasticSigns:Kunststoffschilder`;

  constructor() {
    this.floorplan = this.floorplanService.selectedFloorplan;
  }

  protected get plasticSigns(): readonly PlasticSignConfiguration[] {
    if (this.floorplan.project instanceof FgdsProject) {
      return this.floorplan.project.plasticSigns;
    }
    return [];
  }

  protected addPlasticSign(plasticSign: PlasticSignConfiguration) {
    this.floorplanService.addPlasticSign(plasticSign);
  }

  protected addPlaceholder() {
    this.floorplanService.addPlasticSignPlaceholder();
  }

  protected deletePlasticSign(plasticSign: PlasticSignConfiguration) {
    (this.floorplan.project as FgdsProject).deletePlasticSign(plasticSign);
  }

  drag(plasticSignConfig: PlasticSignConfiguration) {
    this.dragDropService.setDragged({ type: DraggedItemType.PLASTIC_SIGN, config: plasticSignConfig });
  }

  dragPlaceholder() {
    this.dragDropService.setDragged({ type: DraggedItemType.PLASTIC_SIGN_PLACEHOLDER });
  }

  protected updatePlasticSignsItemTextVisibility(visible: boolean) {
    this.floorplan.floorplanState.updatePlasticSignsItemTextVisibility(visible);
  }
}
